import { Link, Navigate } from "react-router-dom";
import { EyeOff, Mail, ShieldCheck, MessageSquare } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdultPage() {
  const { user } = useAuth();

  if (user === null) {
    return <main className="max-w-4xl mx-auto px-4 py-24 text-center text-slate-400">Loading…</main>;
  }
  if (user === false) return <Navigate to="/login?next=/adult" replace />;

  const isPaid = !!user.is_paid;
  const isOpted = !!user.adult_opt_in;

  if (!isPaid) {
    return (
      <main className="min-h-screen bg-slate-950 text-slate-200 flex items-center justify-center px-4">
        <div className="max-w-md text-center">
          <EyeOff className="w-12 h-12 text-slate-600 mx-auto mb-4" />
          <h1 className="font-heading text-2xl text-white mb-2">Members Club only</h1>
          <p className="text-sm text-slate-400 mb-6">This section is available exclusively to $1.99/mo Members Club subscribers.</p>
          <Link to="/membership" className="inline-block px-6 py-3 rounded-full bg-emerald-600 text-white font-bold text-sm hover:bg-emerald-500">Unlock for $1.99/mo</Link>
        </div>
      </main>
    );
  }

  if (!isOpted) {
    return (
      <main className="min-h-screen bg-slate-950 text-slate-200 flex items-center justify-center px-4">
        <div className="max-w-md text-center">
          <ShieldCheck className="w-12 h-12 text-rose-500 mx-auto mb-4" />
          <h1 className="font-heading text-2xl text-white mb-2">Enable the Adult section first</h1>
          <p className="text-sm text-slate-400 mb-6">Head back to your dashboard and confirm you are 18+ to unlock this area.</p>
          <Link to="/dashboard" className="inline-block px-6 py-3 rounded-full bg-slate-800 text-white text-sm hover:bg-slate-700 border border-slate-700">Go to dashboard</Link>
        </div>
      </main>
    );
  }

  return (
    <main data-testid="adult-page" className="min-h-screen bg-slate-950 text-slate-200">
      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16 sm:py-24">
        <p className="uppercase text-xs tracking-[0.3em] font-bold text-rose-500 mb-3">Adult · 18+ Section</p>
        <h1 className="font-heading text-3xl sm:text-4xl text-white leading-tight mb-4">Private high-payout offers</h1>
        <p className="text-slate-400 leading-relaxed mb-10 max-w-2xl">
          Curated adult (webcam / dating / creator) affiliate offers that pay the highest commissions in the industry.
          Distribution is deliberately private — offers are shared 1-on-1 with vetted Members Club subscribers to protect
          the payout rates and keep the traffic clean.
        </p>

        <div className="bg-gradient-to-br from-slate-900 to-slate-950 border border-slate-800 rounded-2xl p-8 sm:p-10">
          <div className="w-12 h-12 rounded-full bg-rose-500/20 border border-rose-500/40 flex items-center justify-center mb-4">
            <Mail className="w-6 h-6 text-rose-400" />
          </div>
          <h2 className="text-2xl font-heading text-white mb-2">Contact admin to get on the list</h2>
          <p className="text-sm text-slate-400 leading-relaxed mb-6 max-w-lg">
            Message the Social Flats team with your traffic sources (Instagram, TikTok, Twitter, Reddit, etc.) and the
            niches you&apos;re comfortable promoting. We&apos;ll send back the current list of active private offers with
            payout rates and your personal tracking links.
          </p>
          <Link
            to="/about#contact"
            data-testid="adult-contact-admin-link"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-rose-600 text-white font-bold text-sm hover:bg-rose-500"
          >
            <MessageSquare className="w-4 h-4" /> Contact admin →
          </Link>
        </div>

        <p className="text-xs text-slate-600 mt-8 leading-relaxed">
          By using this section you re-confirm you are 18 years of age or older. All offers are provided by third-party
          networks and Social Flats acts only as an introduction service. Payouts and terms are set by each network.
        </p>
      </div>
    </main>
  );
}
